import {
  Switch,
  Route,
  withRouter
} from "react-router-dom";
import React, {Component} from "react";
import './App.css';
import Ninja from './Ninja';
import NinjaPrivacy from './NinjaPrivacy';
import ABCKana from './ABCKana';
import ABCKanaPrivacy from "./ABCKanaPrivacy";
class App extends Component {
  constructor(props) {
    super(props);
}
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <Switch>
            <Route path="/ninja-agreement"> <Ninja></Ninja> </Route>
            <Route path="/ninja-privacy"> <NinjaPrivacy></NinjaPrivacy> </Route>
            <Route path="/abckana-agreement"><ABCKana></ABCKana></Route>
            <Route path="/abckana-privacy"><ABCKanaPrivacy></ABCKanaPrivacy></Route>
            <Route path="/"><h1>"KesterSoftware.com"</h1> </Route>
          </Switch>
        </header>
      </div>
    );
  }
}
export default withRouter(App);